// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2klQT","content":"styles_content__1FJ1H","row":"styles_row__2huMA","footer":"styles_footer__1TbNS","phraseLength":"styles_phraseLength__m2Jfu"};